/**
 * Compares two sortable cell values for table sorting.
 *
 * Blank values (null / undefined / '') are skipped from the ranking and always
 * sorted to the end, regardless of direction — so "N/A" rows group together at
 * the bottom instead of scattering above and below the real values.
 *
 * Non-blank values use natural locale compare (`numeric: true`, so "2" sorts
 * before "10" and numeric strings like ISBNs order correctly), with the sort
 * direction folded in so callers no longer reverse() the whole list (a blanket
 * reverse would flip the blanks to the top when descending).
 */
export const compareSortValues = (
  a: unknown,
  b: unknown,
  descending: boolean
): number => {
  const aBlank = a == null || a === '';
  const bBlank = b == null || b === '';
  if (aBlank && bBlank) return 0;
  if (aBlank) return 1;
  if (bBlank) return -1;

  const cmp = String(a).localeCompare(String(b), 'en', { numeric: true });
  return descending ? -cmp : cmp;
};
